// Nav: "Connect wallet" → short address. Clicking the address opens a small menu (Rewards, copy, disconnect). The connected wallet is the account; there is no sign-in. Also marks the current page and
// points the X links at config.xHandle.
import { config, xProfileUrl } from "./config.js";
import { esc, shortAddr } from "./format.js";
import { toast } from "./toast.js";
import { $, copyText } from "./ui.js";
import { connect, forget, friendlyError, hasWallet, NO_WALLET_MESSAGE, onWallet, state as wallet } from "./wallet.js";

let menu = null;

export function initNav() {
  markCurrent();
  const btn = $("#connect");
  if (!btn) return;
  btn.addEventListener("click", async (e) => {
    e.stopPropagation();
    if (!wallet.address) {
      if (!hasWallet()) { toast(NO_WALLET_MESSAGE, 6500); return; }
      try { await connect(); } catch (err) { toast(friendlyError(err)); }
      return;
    }
    menu ? closeMenu() : openMenu();
  });
  document.addEventListener("click", (e) => { if (menu && !menu.contains(e.target)) closeMenu(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && menu) { closeMenu(); btn.focus(); } });
  onWallet(render);
  render();
}

function markCurrent() {
  const path = location.pathname.replace(/\.html$/, "").replace(/\/+$/, "") || "/";
  document.querySelectorAll(".nav-links a[href]").forEach((a) => {
    const href = a.getAttribute("href");
    if (href && href.startsWith("/") && !href.includes("#") && (path === href || path.startsWith(`${href}/`))) a.setAttribute("aria-current", "page");
  });
}

export function applyConfigToChrome(cfg = config()) {
  const h = cfg.xHandle ? `@${String(cfg.xHandle).replace(/^@/, "")}` : "";
  // no X account set yet: hide the X links instead of pointing them somewhere else
  document.querySelectorAll("[data-x]").forEach((a) => {
    if (h) a.href = xProfileUrl(h);
    const box = a.closest(".footer-col") || a;
    box.style.display = h ? "" : "none";
  });
  const xh = document.getElementById("xHandle");
  if (xh && h) xh.textContent = h;
  document.querySelectorAll("[data-chain]").forEach((el) => { el.textContent = "SOL"; });
  document.querySelectorAll("[data-builton]").forEach((el) => { el.textContent = "pump.fun"; });
}

function render() {
  const btn = $("#connect");
  if (!btn) return;
  if (wallet.address) {
    btn.textContent = shortAddr(wallet.address);
    btn.classList.add("connected");
    btn.title = wallet.address;
  } else {
    btn.textContent = "Connect wallet";
    btn.classList.remove("connected");
    btn.removeAttribute("title");
    closeMenu();
  }
  if (menu) fillMenu();
}

function openMenu() {
  const host = $("#wallet");
  if (!host) return;
  menu = document.createElement("div");
  menu.className = "wallet-menu";
  menu.id = "walletMenu";
  menu.setAttribute("role", "menu");
  menu.setAttribute("data-testid", "wallet-menu");
  menu.setAttribute("data-lenis-prevent", "");
  host.appendChild(menu);
  fillMenu();
  $("#connect").setAttribute("aria-expanded", "true");
  menu.addEventListener("click", onMenuClick);
}

function closeMenu() {
  if (!menu) return;
  menu.remove();
  menu = null;
  $("#connect")?.setAttribute("aria-expanded", "false");
}

function fillMenu() {
  menu.innerHTML = `
    <div class="wallet-menu-head"><strong>${esc(shortAddr(wallet.address, 6, 6))}</strong><span>Solana</span></div>
    <a role="menuitem" href="/rewards" data-testid="menu-rewards">Rewards</a>
    <button type="button" role="menuitem" data-act="copy" data-testid="menu-copy">Copy address</button>
    <button type="button" role="menuitem" data-act="forget" data-testid="menu-disconnect">Disconnect</button>`;
}

async function onMenuClick(e) {
  const b = e.target.closest("[data-act]");
  if (!b) return;
  e.stopPropagation();
  const act = b.dataset.act;
  closeMenu();
  try {
    if (act === "copy") toast((await copyText(wallet.address)) ? "Address copied." : wallet.address, 4000);
    if (act === "forget") {
      await forget();
      toast("Disconnected. To fully remove access, disconnect this site in your wallet too.", 5000);
    }
  } catch (err) {
    toast(friendlyError(err), 5000);
  }
}
